import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

const languageMap: { [key: string]: string } = {
  en: 'English',
  de: 'German',
  es: 'Spanish',
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'en',
    // backend: {
    //   loadPath: '/locales/{{lng}}/{{ns}}.json'
    // }
  });
// .catch(e => console.log(e));

export default i18n;

export const handleLanguageChange = (option: string) => {
  i18n.changeLanguage(option).catch((e) => console.log(e));
};

export const getCurrentLanguage = () => {
  let currentLanguageCode = i18n.language || 'en';
  // all codes are < 2 but by default on first load
  // code is en-CA [code-region] or chinese code is zh_Hans_CN
  // filering chinese out to return en for mapping any other non supported codes 😎
  if (currentLanguageCode.length > 2 && !currentLanguageCode.includes('Hans')) {
    currentLanguageCode = 'en';
  }
  const currentLanguageName = languageMap[currentLanguageCode];
  return { label: currentLanguageName, value: currentLanguageCode };
};

export function getLanguageFromLanguageCode(languageCode: string) {
  try {
    const locale = getCurrentLanguage().value;

    const displayNames = new Intl.DisplayNames([locale], { type: 'language' });
    return displayNames.of(languageCode) || languageCode;
  } catch (error) {
    console.warn('Failed to get language display name:', error);
    return languageCode;
  }
}
